import k from '../k'
import { stats } from '../state/globals'

export default (reason: string) => {
  stats.durability = 60
  stats.energy = 60
  stats.parts = 0
  stats.isCharging = false
  stats.isJumping = false
  stats.isMovingLeft = false
  stats.isMovingRight = false

  stats.death = reason
  k.go('gameOver')
}
